<template>
  <div class="mainContent helpContent">
    <pageHead device="desktop" page="disclaimer" :title="$t('store.disclaimer_title')"/>
    <div class="rule container">
      <h1 class="title lkrule"><span>{{ $t("store.disclaimer_title") }}</span></h1>
      <section
        class="rule-cont"
        v-for="(item, index) in $t('store.disclaimer_list')"
        :key="index"
      >
        <h1 class="title">{{ item.title }}</h1>
        <p>{{ item.cont1 }}</p>
        <p>{{ item.cont2 }}</p>
        <p>{{ item.cont3 }}</p>
        <p>{{ item.cont4 }}</p>
        <p>{{ item.cont5 }}</p>
        <p>{{ item.cont6 }}</p>
        <p>{{ item.cont7 }}</p>
        <p>{{ item.cont8 }}</p>
        <p>{{ item.cont9 }}</p>
        <div class="title text-danger">{{ item.danger }}</div>
      </section>
    </div>
  </div>
</template>
<script>
  import pageHead from "~/components/common/pageHead.vue";
  export default {
    components: { pageHead }
  };
</script>
